import { rtkApi } from "../rtkApi";
import { Segment } from "src/types/segment";

export const groupsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getGroups: build.query<Record<number, Segment>, void>({
      query: () => ({
        url: "/segments",
        method: "GET",
      }),
      transformResponse: (response: { segments: Segment[] }) => {
        const groups: Record<number, Segment> = {};
        response.segments.forEach((group) => (groups[group.id] = group));
        return groups;
      },
      providesTags: (result) =>
        result ? [{ type: "Groups", id: "LIST" }] : [],
    }),
    getGroupMembers: build.query<{ id: number; members: number[] }, number>({
      query: (id) => ({
        url: `/segments/${id}`,
        method: "GET",
      }),
      transformResponse: (resp: { ids: number[] }, _meta, arg) => ({
        id: arg,
        members: resp.ids,
      }),
      providesTags: (result, _error, id) =>
        result ? [{ type: "Groups", id }] : [],
    }),
    updateGroupMembers: build.mutation<void, { id: number; members: number[] }>(
      {
        query: ({ id, members }) => ({
          url: `/segments/${id}/users`,
          method: "POST",
          body: { ids: members },
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: "Groups", id }],
      },
    ),
    addGroup: build.mutation<
      Segment,
      {
        name: string;
        is_social: boolean;
        members?: number[];
        for_tm_only: boolean;
        segment_type: number;
      }
    >({
      query: (body) => ({
        url: "/segments/new",
        method: "PUT",
        body,
      }),
      transformResponse: (response: any, _meta, arg) => {
        return {
          id: response.id,
          ...arg,
          is_default: false,
        };
      },
      invalidatesTags: [{ type: "Groups", id: "LIST" }],
    }),
    updateGroup: build.mutation<
      Segment,
      {
        name: string;
        is_social: boolean;
        id: number;
        for_tm_only: boolean;
        segment_type: number;
      }
    >({
      query: (payload) => {
        return {
          url: `/segments/${payload.id}/settings`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Groups", id: "LIST" },
        { type: "Groups", id },
      ],
    }),
    deleteGroup: build.mutation<void, number>({
      query: (id) => ({
        url: `/segments/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Groups", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetGroupsQuery,
  useGetGroupMembersQuery,
  useUpdateGroupMembersMutation,
  useAddGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
} = groupsApi;
